import React from "react";
import { BrokerStatus } from "../../../features/profileProtection/profileProtectionData";
import "./protection.css";
import { Chip } from "@kidslivesafe/sc-react";

type StatusLabel =
  | BrokerStatus
  | "not_started"
  | "in_progress"
  | "completed"
  | "public"
  | "hidden"
  | "unknown";

interface StatusPillProps {
  status: StatusLabel;
}

const labelMap: Record<StatusLabel, string> = {
  likely_exposure: "Likely Exposure",
  queued: "Queued",
  working: "In Progress",
  submitted: "Submitted",
  waiting_on_you: "Needs Action",
  removed: "Removed",
  couldnt_complete: "Could Not Complete",
  not_started: "Not Started",
  in_progress: "In Progress",
  completed: "Completed",
  public: "Public",
  hidden: "Hidden",
  unknown: "Unknown",
};

const colorMap: Record<StatusLabel, "success" | "error" | "warning" | "gray"> =
  {
    likely_exposure: "warning",
    queued: "gray",
    working: "success",
    submitted: "success",
    waiting_on_you: "error",
    removed: "success",
    couldnt_complete: "error",
    not_started: "gray",
    in_progress: "warning",
    completed: "success",
    public: "warning",
    hidden: "gray",
    unknown: "gray",
  };

const StatusPill: React.FC<StatusPillProps> = ({ status }) => {
  return <Chip chipText={labelMap[status]} color={colorMap[status]} />;
};

export default StatusPill;
